import { Box, Stack, Text } from "@chakra-ui/react";

const CardItem = ({ item }) => {
    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            border="1px"
            borderColor="#E2E2E2"
            borderRadius="21px"
            px={4}
            py={8}
            justifyContent="flex-start"
            minW={{ base: "240px", md: "150px" }}
        >
            <Box
                borderRadius="full"
                w="120px"
                h="120px"
                bg="accent.500"
                display="flex"
                justifyContent="center"
                alignItems="center"
                backgroundImage={`url(${item.image})`}
                backgroundSize="cover"
                backgroundPosition="center center"
                mb={6}
            />
            <Stack>
                <Text fontSize="md" fontWeight="bold" textAlign="center" color="accent.500" p={0}>
                    {item.name}
                </Text>
                <Text fontSize="sm" fontWeight="400" textAlign="center" color="accent.500" p={0}>
                    {item.job_position}
                </Text>
            </Stack>
        </Box>
    );
};

export default CardItem;
